import { createSelector } from 'reselect';

export const selectBonusById = state => state.bonusById;

export const selectBonusByIdConfig = createSelector(selectBonusById, ({ config }) => config);

export const selectBonusByIdByNamespace = createSelector(
  [
    selectBonusById,
    (state, namespace = 'default') => namespace,
  ],
  (bonusByIdReducer, namespace) => {
    const { defaults = {} } = bonusByIdReducer;
    return bonusByIdReducer[`namespace-${namespace}`] || defaults;
  },
);

export const makeSelectBonusByIdPlacement = () => (
  createSelector(selectBonusByIdByNamespace, ({ placement }) => placement)
);

export const makeSelectBonusByIdIsLoaded = () => (
  createSelector(selectBonusByIdByNamespace, ({ isLoaded }) => isLoaded)
);
export const makeSelectBonusByIdIsLoading = () => (
  createSelector(selectBonusByIdByNamespace, ({ isLoading }) => isLoading)
);
